import { useTranslation } from 'react-i18next';
import { FileUploadEvidenceContentType } from './helpers';
import { UploadedEvidence } from './UploadedEvidence';

export const ReportFileUploadedEvidence = (props: {
  evidenceContent: FileUploadEvidenceContentType[];
  evidenceTitle: string;
  isFileUploadEnabled?: boolean;
  isReporterViewEvidenceDisabled?: boolean;
  reportId?: string;
  'data-testid'?: string;
}) => {
  const { t } = useTranslation();

  return props.evidenceContent.length && props.reportId ? (
    <UploadedEvidence
      data-testid={props['data-testid']}
      files={props.evidenceContent || []}
      reportId={props.reportId}
      localisedText={{
        tableTitle: t('public.Evidence.tableTitle'),
        webErrorMessage: t('public.Evidence.webErrorMessage'),
        mobileErrorMessage: t('public.Evidence.mobileErrorMessage'),
        nameHeading: t('public.Evidence.nameHeading'),
        addedHeading: t('public.Evidence.addedHeading'),
        statusHeading: t('public.Evidence.statusHeading'),
        failedToOpenFileMessage: t('public.Evidence.failedToOpenFileMessage'),
        fileStatuses: {
          pendingUpload: t('public.Evidence.fileStatuses.pendingUpload'),
          passedUpload: t('public.Evidence.fileStatuses.passedUpload'),
          infectedUpload: t('public.Evidence.fileStatuses.infectedUpload'),
          readyForDownload: t('public.Evidence.fileStatuses.readyForDownload'),
        },
      }}
      downloadEvidenceDisabled={props.isReporterViewEvidenceDisabled}
    />
  ) : (
    <>
      <h2 data-testid="evidence-title">{props.evidenceTitle}</h2>
      <p data-testid="evidence-content">
        <i data-testid="skipped">{t('public.PublicReport.skipped')}</i>
      </p>
    </>
  );
};
